module.exports = __webpack_public_path__ + "static/media/client-image-1.12cd1672.png";